/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './allergy-symptom.reducer';

export const AllergySymptomDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const allergySymptomEntity = useAppSelector(state => state.allergySymptom.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="allergySymptomDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.allergySymptom.detail.title">AllergySymptom</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.allergySymptom.id">Id</Translate>
            </span>
          </dt>
          <dd>{allergySymptomEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.allergySymptom.active">Active</Translate>
            </span>
          </dt>
          <dd>{allergySymptomEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="symptom">
              <Translate contentKey="tinyMedicRestApp.allergySymptom.symptom">Symptom</Translate>
            </span>
          </dt>
          <dd>{allergySymptomEntity.symptom}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.allergySymptom.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{allergySymptomEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.allergySymptom.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{allergySymptomEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.allergySymptom.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{allergySymptomEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.allergySymptom.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{allergySymptomEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/allergy-symptom" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/allergy-symptom/${allergySymptomEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AllergySymptomDetail;
